import { useEffect, useState } from 'react';
import { useLang } from '../i18n';

const PHONE = '(805) 922-9684';
const PHONE_HREF = 'tel:+18059229684';
const LOGO_URL = '/images/logo.png';

function PhoneIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.66h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l.91-1.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  );
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { lang, setLanguage, t } = useLang();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`site-header${scrolled ? ' scrolled' : ''}`}
    >
      <div className="header-inner">
        <a href="#" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }} aria-label="Super Muffler Inc. — Home">
          <img
            src={LOGO_URL}
            alt="Super Muffler Inc. logo"
            className="header-logo"
          />
        </a>

        {/* Desktop nav */}
        <div className="header-desktop-ctas">
          <div className="lang-picker" data-testid="lang-picker">
            <button
              onClick={() => setLanguage('en')}
              className={`lang-option${lang === 'en' ? ' lang-active' : ''}`}
              data-testid="lang-pick-en"
            >
              English
            </button>
            <span className="lang-divider">|</span>
            <button
              onClick={() => setLanguage('es')}
              className={`lang-option${lang === 'es' ? ' lang-active' : ''}`}
              data-testid="lang-pick-es"
            >
              Espa&ntilde;ol
            </button>
          </div>
          <a
            href={PHONE_HREF}
            data-testid="header-free-inspection-cta"
            style={{ color: 'var(--sm-blue)', fontFamily: 'Archivo, sans-serif', fontWeight: 700, fontSize: '14px', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.3rem' }}
          >
            {t.freeInspection}
          </a>
          <a
            href={PHONE_HREF}
            data-testid="header-phone-cta"
            className="btn-primary"
            style={{ fontSize: '14px', padding: '0.65rem 1.2rem', borderRadius: 10 }}
          >
            <PhoneIcon />
            {PHONE}
          </a>
        </div>

        {/* Mobile nav */}
        <div className="header-mobile-group">
          <div className="lang-picker lang-picker-mobile" data-testid="lang-picker-mobile">
            <button
              onClick={() => setLanguage('en')}
              className={`lang-option${lang === 'en' ? ' lang-active' : ''}`}
              data-testid="lang-pick-en-mobile"
            >
              English
            </button>
            <span className="lang-divider">|</span>
            <button
              onClick={() => setLanguage('es')}
              className={`lang-option${lang === 'es' ? ' lang-active' : ''}`}
              data-testid="lang-pick-es-mobile"
            >
              Espa&ntilde;ol
            </button>
          </div>
          <a
            href={PHONE_HREF}
            data-testid="header-phone-mobile"
            className="header-mobile-cta btn-primary"
            style={{ fontSize: '14px', padding: '0.6rem 1rem', borderRadius: 10 }}
          >
            <PhoneIcon />
            {t.callNow}
          </a>
        </div>
      </div>
    </header>
  );
}
